import { temporaryOrderDomainStore } from '../../temporary-store/store';
export const getInProgressItemCount = () => temporaryOrderDomainStore.data.inProgressItems.length;
